import { render, staticRenderFns } from "./table3.vue?vue&type=template&id=61386d9e&scoped=true&"
import script from "./table3.vue?vue&type=script&lang=js&"
export * from "./table3.vue?vue&type=script&lang=js&"
import style0 from "./table3.vue?vue&type=style&index=0&id=61386d9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61386d9e",
  null
  
)

export default component.exports